module.exports = fox._r("images/crowdfunding-bg.jpg", __webpack_public_path__ + "_/_/_/root/images/crowdfunding-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/crowdfunding-bg.jpg
// module id = 187
// module chunks = 4